import { SERVER_API } from "../../Constant";
import axios from "axios";

// Transfer Vehicle
export const TransferVehicle_api = async (payload: any) => {
  try {
    const formData = new FormData();
    formData.append("inputs", JSON.stringify(payload));
    const response = await axios.post(
      `${SERVER_API}/Stock/transfer_vehicle.php`,
      formData,
    );
    return response.data;
  } catch (error) {
    console.error("Transfer vehicle failed:", error);
    return { error: "Transfer vehicle failed" };
  }
};

// Mark Vehicle Sold
export const MarkVehicleSold_api = async (payload: any) => {
  try {
    const formData = new FormData();
    formData.append("inputs", JSON.stringify(payload));
    const response = await axios.post(
      `${SERVER_API}/Stock/mark_vehicle_sold.php`,
      formData,
    );
    return response.data;
  } catch (error) {
    console.error("Mark vehicle sold failed:", error);
    return { error: "Mark vehicle sold failed" };
  }
};

// Fetch Dealer Stock
export const FetchDealerStock_api = async (
  dealer_id: number,
  page = 1,
  limit = 10,
  search = "",
  status = "",
) => {
  try {
    const response = await axios.get(
      `${SERVER_API}/Stock/fetch_dealer_stock.php`,
      {
        params: { dealer_id, page, limit, search, status },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Fetch dealer stock failed:", error);
    return { error: "Fetch dealer stock failed" };
  }
};

export const FetchAvailableVehicles_api = async (
  page = 1,
  limit = 10,
  filters: any = {},
) => {
  try {
    const response = await axios.get(
      `${SERVER_API}/Stock/fetch_available_vehicles.php`,
      {
        params: { page, limit, ...filters },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Fetch available vehicles failed:", error);
    return { error: "Fetch available vehicles failed" };
  }
};

// Fetch Stock Transfer History
export const FetchStockTransferHistory_api = async (
  page = 1,
  limit = 10,
  search = "",
) => {
  try {
    const response = await axios.get(
      `${SERVER_API}/Stock/fetch_transfer_history.php`,
      {
        params: { page, limit, search },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Fetch stock transfer history failed:", error);
    return { error: "Fetch stock transfer history failed" };
  }
};

// Fetch Global History Feed
export const FetchGlobalHistoryFeed_api = async (
  page = 1,
  limit = 10,
  search = "",
) => {
  try {
    const response = await axios.get(
      `${SERVER_API}/Stock/fetch_global_history_feed.php`,
      {
        params: { page, limit, search },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Fetch global history feed failed:", error);
    return { error: "Fetch global history feed failed" };
  }
};

// Fetch Vehicle Timeline
export const FetchVehicleTimeline_api = async (search: string) => {
  try {
    const response = await axios.get(
      `${SERVER_API}/Stock/fetch_vehicle_timeline.php?search=${search}`,
    );
    return response.data;
  } catch (error) {
    console.error("Fetch vehicle timeline failed:", error);
    return { error: "Fetch vehicle timeline failed" };
  }
};

// Fetch Returned Vehicles Report
export const FetchReturnedVehiclesReport_api = async (
  startDate?: string,
  endDate?: string,
  modelId?: number,
  dealerId?: number,
) => {
  try {
    const params: any = {};
    if (startDate) params.start_date = startDate;
    if (endDate) params.end_date = endDate;
    if (modelId) params.model_id = modelId;
    if (dealerId) params.dealer_id = dealerId;

    const response = await axios.get(
      `${SERVER_API}/Reports/fetch_returned_vehicles_report.php`,
      { params },
    );
    return response.data;
  } catch (error) {
    console.error("Fetch returned vehicles report failed:", error);
    return { error: "Fetch returned vehicles report failed" };
  }
};
